import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StructureCouranteService {

    private readonly _id = new BehaviorSubject<string | null>(this.lireDepuisSession());

    readonly structureId$ = this._id.asObservable();

    private lireDepuisSession(): string | null {
        const v = sessionStorage.getItem('courrante');
        return (v && v !== 'null' && v !== 'undefined') ? v : null;
    }

    setStructure(id: string): void {
        sessionStorage.setItem('courrante', id);
        this._id.next(id);
    }

    get courant(): string | null {
        return this._id.value;
    }
}
